"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupFieldLogic = void 0;
var lookup_fieldtype_1 = require("./lookup.fieldtype");
Object.defineProperty(exports, "LookupFieldLogic", { enumerable: true, get: function () { return lookup_fieldtype_1.LookupFieldLogic; } });
